import React, { useEffect } from 'react';
import styles from './DashboardCurrencyWarningOverlay.module.scss';
import { useCurrencyContext } from 'app/contexts/Currency/CurrencyContext';
import { ExternalLinks } from 'shared/enums/external-links.enum';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';
import Spinner, { SPINNER_SIZES } from 'shared/components/andtComponents/Spinner';

interface DashboardCurrencyWarningOverlayProps {
  onDismiss: () => void;
}

export const DashboardCurrencyWarningOverlay: React.FC<DashboardCurrencyWarningOverlayProps> = ({
  onDismiss,
}: DashboardCurrencyWarningOverlayProps): React.ReactNode => {
  const currencyContext = useCurrencyContext();

  const [rate, setRate] = React.useState<number>(currencyContext.exchangeRate ?? 1);

  useEffect(() => {
    if (currencyContext?.exchangeRate) {
      setRate(currencyContext.exchangeRate);
    }
  }, [currencyContext?.exchangeRate]);

  return (
    <div className={styles.warningContainer}>
      <div className={styles.content}>
        {currencyContext?.isLoading ? (
          <Spinner size={SPINNER_SIZES.XL_SMALL} />
        ) : (
          <div className={styles.texts}>
            <div className={styles.warningTitle}>
              <GenerateIcon className={styles.icon} iconName={ICONS.solidCalculatorGear.name} />
              <div className={styles.title}>Ad-Hoc Currency Conversion</div>
            </div>
            <div className={styles.warningBody}>
              <b>Anomalies, YTD Savings and Forecasting</b> panels values converted ad-hoc to{' '}
              <b>Processing Currency ({currencyContext?.currencyInUse?.code})</b> for a unified view in the dashboard.
              <br />
              Please note: slight differences may appear, since the original data uses the{' '}
              <b>Provider Currency ({currencyContext?.providerCurrency}).</b>
            </div>

            <div className={styles.warningBody}>
              <b>
                Conversion rate applied: {rate} {currencyContext?.currencyInUse?.symbolNative}
              </b>
            </div>
            <div>
              <a href={ExternalLinks.CurrenciesDocumentation} target="_blank" className={styles.navigateText}>
                Learn more
              </a>
            </div>
          </div>
        )}

        <GenerateIcon
          className={styles.closeButton}
          iconName={ICONS.xMark.name}
          onClick={() => onDismiss()}
        ></GenerateIcon>
      </div>
    </div>
  );
};
